import SaudiaImg from "../images/saudia1.jpg";
import DubaiImg from "../images/dubai.jpg";
import TurkeyImg from "../images/turkey.jpg";
import MalaysiaImg from "../images/malaysia.jpg";
import UkImg from "../images/uk.jpg";
import UsaImg from "../images/usa.jpg";
import CanadaImg from "../images/canada.jpg";
import QatarImg from "../images/qatar.jpg";
import SectionHeading from "./ui/SectionHeading";
import GradientButton from "./ui/GradientButton";
import Reveal from "./ui/Reveal";

const visas = [
  { country: "Saudi Arabia", image: SaudiaImg },
  { country: "UAE", image: DubaiImg },
  { country: "Turkey", image: TurkeyImg },
  { country: "Malaysia", image: MalaysiaImg },
  { country: "UK", image: UkImg },
  { country: "USA", image: UsaImg },
  { country: "Canada", image: CanadaImg },
  { country: "Qatar", image: QatarImg },
];

const VisaCard = ({ country, image }) => (
  <div className="group relative min-h-[220px] overflow-hidden rounded-2xl shadow-[0_16px_38px_rgba(17,17,17,0.14)]">
    <img
      src={image}
      alt={country}
      className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
    />
    <div className="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-t from-brand-dark/85 via-brand-dark/45 to-brand-dark/20 p-4 text-center text-white">
      <h3 className="mb-3 text-2xl font-bold">{country}</h3>
      <GradientButton variant="green" href="#contact">
        Apply Now
      </GradientButton>
    </div>
  </div>
);

const Visas = () => {
  return (
    <section id="visas" className="section-pad bg-[#dfecd5]">
      <SectionHeading
        eyebrow="Visa Services"
        title="Visa Packages"
        subtitle="Fast, reliable visa processing for Saudi Arabia and destinations worldwide."
      />
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {visas.map((visa, i) => (
          <Reveal key={visa.country} delay={i * 0.06}>
            <VisaCard country={visa.country} image={visa.image} />
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Visas;
